module.exports = __webpack_public_path__ + "img/logo.ebcb3627.png";